// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import '../node_modules/bootstrap/dist/js/bootstrap.js'
import '../node_modules/toastr/build/toastr.min.css'
import '../node_modules/font-awesome/css/font-awesome.min.css'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import './css/hero.css'
import './css/featured.css'
import './css/global.css'
import './css/top-downloads.css'
import './css/map-card.css'
import './css/callouts.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAgile from 'vue-agile'
import { store } from './framework/store';
import storePlugin from './framework/storePlugin'

Vue.config.productionTip = false

Vue.filter('date', function(value, format='MM/DD/YYYY') {
  if(!value) return '';
  return moment(value).format(format);
});

Vue.filter('dateTime', function(value, format = 'MM/DD/YYYY hh:mm a'){
  if(!value) return '';
  return moment(value).format(format);
})

Vue.filter('arrayToString', function(value) {
  if(!value) return '';
  return value.join(', ');
});

Vue.use(VueAgile);
Vue.use(storePlugin, { store });
store.loadFromLocalStorage();

/* eslint-disable no-new */
const i = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js